import { useWidget } from "../../../providers/widget"
import { DescriptionWidgetConfig, descriptionSectionKeys } from "../config"
import Stylesheet from "../../../components/Stylesheet"
import DescriptionContent from "./DescriptionContent"
import WebFont from "../../../components/WebFont"
import WidgetSection from "../../../components/WidgetSection"
import { useDescriptionCss } from "../hooks/useDescriptionCss"
import { useFetchDescription } from "../data"
import { findObjectByLocale, useLocaleDetection } from "../../../hooks/locale"
import { resolveWidgetSpacingStyle } from "@homerunner-next/widget-core/spacing"

export function DescriptionWidgetContent() {
  const { options, resolvedTheme } = useWidget<DescriptionWidgetConfig>()
  const cssString = useDescriptionCss()
  // The same resolution <DescriptionContent /> uses, so the section title's
  // presence gate below and the body it sits over can never disagree about
  // which locale row is being rendered (#1535).
  const { detectedLocale } = useLocaleDetection(
    options.language.useAutoDetectedLocale,
    options.language.locale,
  )

  // Section title only renders once we have actual, non-blank description
  // content for the current locale — a resolved-but-blank row (e.g. Guesty
  // sandbox properties, #996) must not produce an orphaned title over a body
  // that <DescriptionSections> correctly renders as nothing (#1002 item 2).
  // React Query dedupes with the call inside <DescriptionContent />.
  const { data } = useFetchDescription(options.filter)
  const description = findObjectByLocale(data?.result?.descriptions ?? [], detectedLocale)
  const hasContent = !!description && descriptionSectionKeys.some((key) => {
    const value = description[key]
    return typeof value === 'string' && value.trim() !== ''
  })

  return (
    <div
      className={`homerunner-description-container homerunner-description-app w-full ${resolvedTheme === 'dark' ? 'dark' : ''}`}
      style={resolveWidgetSpacingStyle(options)}
      suppressHydrationWarning
    >
      <WebFont />
      <Stylesheet css={cssString} />
      {hasContent && (
        <WidgetSection show={options.section?.show} title={options.section?.title} forceHeadingInMarkup />
      )}
      <DescriptionContent />
    </div>
  )
}
